__turbopack_context__.v({
  "actions": "ConsentBanner-module__N-F7xW__actions",
  "banner": "ConsentBanner-module__N-F7xW__banner",
  "button": "ConsentBanner-module__N-F7xW__button",
  "link": "ConsentBanner-module__N-F7xW__link",
  "text": "ConsentBanner-module__N-F7xW__text",
  "title": "ConsentBanner-module__N-F7xW__title",
});
